import { Typography } from "@packages/ds";
import styled from "styled-components";

import Button from "ds/Button";
import WizardImageDark from "Vendor_resources/images/wizard_start-dark.png";
import WizardImage from "Vendor_resources/images/wizard_start.png";

export const Wrapper = styled.div`
  display: flex;
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 29% 32px 32px 32px;
  background: transparent
    url(${props =>
      props.theme.name === "dark" ? WizardImageDark : WizardImage})
    0 0 / 100% no-repeat;

  h2 {
    margin-bottom: 8px;
    line-height: 33px;
  }

  p {
    flex: 1;
    margin: 0 0 5px;
    color: var(--section-ebony-light-color, var(--ebony-light));
    font-size: 14px;
    line-height: 24px;
  }

  @media (min-width: 900px) {
    padding-top: 19%;
  }

  @media (min-width: 1280px) {
    padding-top: 180px;
    background-size: auto 180px;
    background-position: top center;
  }

  @media (min-width: 1680px) {
    padding-top: 236px;
    background-size: auto 236px;
  }

  @media (min-width: 1920px) {
    padding-top: 32px;
    background: none;
  }
`;

export const Footer = styled.footer`
  display: flex;
  margin-top: 32px;
  align-items: center;
  gap: 5px;
`;

export const Pipe = styled.hr`
  height: 24px;
  width: 1px;
  margin: 0 15px 0 0;
  background-color: var(--mode-bg-neutral-weak);
`;

export const FooterButton = styled(Button)`
  transition: all 0.1s ease;
  margin-left: -7px;
  margin-right: 5px;
  padding-left: 7px;
  padding-right: 4px;

  &:hover {
    padding-left: 0;
    padding-right: 11px;

    &:after {
      display: none;
    }
  }
`;

export const ImageContainer = styled.div`
  display: none;
  @media (min-width: 1920px) {
    display: block;
    height: 172px;
    margin: -32px -32px 32px;
    background: url(${props =>
        props.theme.name === "dark" ? WizardImageDark : WizardImage})
      0 0 no-repeat;
    background-size: contain;
  }
`;

export const ProjectTitle = styled(Typography.Title)`
  word-break: break-all;
  margin-bottom: 8px;
`;
